import Alerts from "../util/Alerts";
import React, { useEffect, useRef, useState } from "react";
import { Collapse } from "reactstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import { routes } from "../gen/General";
import { useSelector } from "react-redux";
import Select from "react-select";
import { customStyles, filtro, grupos, gruposList } from "./util";
import { Formik, useFormikContext } from "formik";

import hospitalaria_on from "../assets/img/icon/icon_red_hospitalaria_on.svg";
import hospitalaria_off from "../assets/img/icon/icon_red_hospitalaria_off.svg";
import ambulatoria_on from "../assets/img/icon/icon_red_ambulatoria_on.svg";
import ambulatoria_off from "../assets/img/icon/icon_red_ambulatoria_off.svg";
import farmacias_on from "../assets/img/icon/icon_red_farmacias_on.svg";
import farmacias_off from "../assets/img/icon/icon_red_farmacias_off.svg";
import paquetes_on from "../assets/img/icon/icon_paquetes_selectos_on.svg";
import paquetes_off from "../assets/img/icon/icon_paquetes_selectos_off.svg";
import check_on from "../assets/img/icon/check_on.svg";
import check_off from "../assets/img/icon/check_off.svg";
import buscar from "../assets/img/icon/icon_buscar.svg";
import cerrar_green from "../assets/img/icon/icon_cerrar_green.svg";
import icon_filtro from "../assets/img/icon/icono_filtro.svg";
import { ModalCargando } from "../coms/ModalCargando";
import * as htmlToImage from "html-to-image";
import { BeneficioCardGrande } from "./BeneficioCardPeque";
import { findRed } from "../beneficios/utils";
import { CarouselPrestadores } from "./CarouselPrestadores";

export const Prestadores = () => {
    const alert = useRef(null);
    const firstRender = useRef(true);
    const params = useParams();
    const user = useSelector(state => state.user);

    const [open, setOpen] = useState(true);
    const [espere, setEspere] = useState(false);
    const [polizas, setPolizas] = useState([]);
    const [tipoRedes, setTipoRedes] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [prestadores, setPrestadores] = useState([]); // proveedores
    const [redCoberturas, setRedCoberturas] = useState([]);
    const [beneficios, setBeneficios] = useState([]);
    const [beneficiosAgrupados, setBeneficiosAgrupados] = useState({});
    const [showCardPeque, setShowCardPeque] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [agrupamientoSeleccionado, setAgrupamientoSeleccionado] = useState({ label: "Todos", value: grupos.todos });

    useEffect(() => {
        handleAgrupamiento(agrupamientoSeleccionado);
        if (!firstRender.current) {
            if (beneficios?.length < 1) {
                alert.current.show_error("Sin resultados");
            }
        }
        firstRender.current = false;
    }, [beneficios]);

    useEffect(() => {
        fetchCiudades();
        fetchRedCoberturas();
        let tp = params.tp;
        if (tp === "vam") {
            getAseguradoraVam(user.cedula);
        } else {
            getAseguradora(user.cdCliente);
        }
    }, [params.tp, user]);

    useEffect(() => {
        fetchFiltros();
    }, [polizas]);

    const getAseguradoraVam = param => {
        if (param) {
            axios
                .get(routes.apiVam + "/siniestro/deducible/matrix", {
                    params: {
                        cedula: param,
                        caducada: true,
                    },
                })
                .then(resp => {
                    setPolizas(resp.data);
                })
                .catch(error => {
                    alert.current.handle_error(error);
                });
        }
    };

    const getAseguradora = param => {
        if (param) {
            axios
                .get(routes.api + "/siniestro/aseguradora", {
                    params: {
                        cdCompania: 1,
                        cdCliente: param, //pasar en el componente el siniestro
                        caducada: true,
                    },
                })
                .then(resp => {
                    setPolizas(resp.data);
                })
                .catch(error => {
                    alert.current.handle_error(error);
                });
        }
    };

    const fetchFiltros = () => {
        setIsLoading(true);
        const planesIds = (polizas || []).map(p => p.CD_PLAN);
        axios
            .post(routes.api + "/beneficios/prestadores-filtros", planesIds)
            .then(resp => {
                setEspecialidades(resp.data.especialidades);
                setPrestadores(resp.data.proveedores);
                setTipoRedes(resp.data.tipoRedes);
            })
            .catch(error => {
                alert.current.handle_error(error);
            })
            .finally(() => setIsLoading(false));
    };

    const fetchCiudades = () => {
        axios
            .get(routes.base + "/ciudades")
            .then(resp => {
                setCiudades(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    const search = values => {
        let planes = values?.polizas?.map(i => i.value) || [];
        if (planes.length < 1) {
            planes = handlePlanes(planes);
        }
        const especialidades = values?.especialidades?.map(i => i.value) || [];
        const ciudades = values?.ciudades?.map(i => i.value) || [];
        const prestadores = values?.prestadores?.map(i => i.value) || [];
        const redes = values?.redes || [];
        const tipoRedes = values?.tipoRedes?.map(i => i.value) || [];
        const item = { planes, especialidades, ciudades, prestadores, redes, tipoRedes };
        axios
            .post(routes.base + "/beneficios/prestadores-search", item)
            .then(resp => {
                handleBeneficios(resp.data);
            })
            .catch(err => alert.current.handle_error(err));
        setShowCardPeque(true);
    };

    const handleBeneficios = array => {
        const listaBeneficios = array.map(i => {
            const polizaNm = polizas.find(p => p.CD_PLAN === i.cdPlan) || [];
            return {
                ...i,
                cdPlanTmp: i.cdPlan, // para tener el original
                cdRedCobTmp: i.cdRedCob, // para tener el original
                cdPlan: `${polizaNm?.POLIZA || ""} - ${polizaNm?.DSC_PLAN || ""}`,
                cdRedCob: tipoRedes.find(t => t.id === i.cdRedCob)?.red || "",
            };
        });
        setBeneficios(listaBeneficios);
    };

    const handlePlanes = () => {
        return polizas?.map(i => i.CD_PLAN) || [];
    };

    const fetchRedCoberturas = () => {
        axios
            .get(routes.base + "/red-coberturas")
            .then(resp => setRedCoberturas(resp.data))
            .catch(err => alert.current.handle_error(err));
    };

    function print(id, automatico = false) {
        setEspere(true);
        setTimeout(() => {
            var node = document.getElementById(id);
            htmlToImage
                .toPng(node, { quality: 0.95 })
                .then(dataUrl => {
                    const link = document.createElement("a");
                    link.download = "imagen-beneficio.jpg";
                    link.href = dataUrl;
                    link.click();
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    setEspere(false);
                    automatico && setShowCardPeque(true);
                });
        }, [1000]);
    }

    const handleAgrupamiento = grupo => {
        agrupamiento(grupo?.value);
        setAgrupamientoSeleccionado(grupo);
    };

    const agrupamiento = categoria => {
        const agrupados =
            categoria &&
            beneficios.reduce((group, item) => {
                const category = item[categoria];
                group[category] = group[category] ?? [];
                group[category].push(item);
                return group;
            }, {});
        setBeneficiosAgrupados(agrupados);
    };

    const handleRemoveTags = (item, grupo, values, setFieldValue) => {
        // estado beneficios
        const tipo = item?.tipo || "red";
        let label = item?.label || findRed(item).toUpperCase();
        if (item?.tipo === grupos.ciudad) {
            label = item?.value; // porque modifique a ciudad - provincia
        }
        const value = item?.value || item;
        const newBeneficios = beneficios.filter(b => b[tipo] !== label);

        // formik de etiquetas
        const newValues = values[grupo]?.filter(v => (v.value || v) !== value);
        setFieldValue(grupo, newValues);
        setBeneficios(newBeneficios);
    };

    const handleGrupoNm = (grupo = "") => {
        const grupito = ["undefined", "null"].includes(grupo.toLowerCase());
        if (grupito && agrupamientoSeleccionado.value === grupos.ciudad) {
            return "No se encontraron resultados en las ciudades seleccionadas, te mostramos otras opciones";
        }
        if (grupito && agrupamientoSeleccionado.value === grupos.prestador) {
            return "No se encontraron resultados en los prestadores seleccionados, te mostramos otras opciones";
        }
        return grupito ? "" : grupo;
    };

    return (
        <>
            <div className="content">
                <Alerts ref={alert} />
                <div className="card" style={{ overflow: " hidden " }}>
                    <Formik initialValues={filtro} onSubmit={search}>
                        {({ submitForm, setFieldValue, values }) => (
                            <>
                                <div className="card-body py-0">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-5 p-0">
                                                <Collapse isOpen={open}>
                                                    <div className={"prestadores-filtro"}>
                                                        <div className="bordecito  titulo">
                                                            <div className={"filtro"}>
                                                                <h1 className={""}>
                                                                    <img src={icon_filtro} width={"30"} alt="" />
                                                                    &nbsp;Filtro
                                                                </h1>
                                                            </div>
                                                        </div>
                                                        <FiltroSelect
                                                            name={"polizas"}
                                                            placeholder={"Todas las pólizas"}
                                                            isLoading={isLoading}
                                                            titulo={"Pólizas:"}
                                                            options={polizas.map(
                                                                p =>
                                                                    (p = {
                                                                        value: p.CD_PLAN,
                                                                        label: `${p.POLIZA} - ${p.DSC_PLAN}`,
                                                                        tipo: grupos.poliza,
                                                                    })
                                                            )}
                                                            value={values["polizas"]}
                                                        />
                                                        <div className={"bordecito"}>
                                                            <div className="filtro">
                                                                <h1>Red:</h1>
                                                                <label
                                                                    className={"c-pointer"}
                                                                    onClick={() => {
                                                                        values.redes?.length != 4
                                                                            ? setFieldValue("redes", [
                                                                                  "H",
                                                                                  "A",
                                                                                  "S",
                                                                                  "F",
                                                                              ])
                                                                            : setFieldValue("redes", []);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            values.redes?.length == 4
                                                                                ? check_on
                                                                                : check_off
                                                                        }
                                                                        width={"20"}
                                                                    />
                                                                    &nbsp;Seleccionar todos
                                                                </label>
                                                                <div className="row">
                                                                    <RedCard
                                                                        title={"Red Hospitalaria"}
                                                                        red={"H"}
                                                                        iconos={[hospitalaria_on, hospitalaria_off]}
                                                                    />
                                                                    <RedCard
                                                                        title={"Red Ambulatoria"}
                                                                        red={"A"}
                                                                        iconos={[ambulatoria_on, ambulatoria_off]}
                                                                    />
                                                                    <RedCard
                                                                        title={"Paquetes Selectos"}
                                                                        red={"S"}
                                                                        iconos={[paquetes_on, paquetes_off]}
                                                                    />
                                                                    <RedCard
                                                                        title={"Red Farmacias"}
                                                                        red={"F"}
                                                                        iconos={[farmacias_on, farmacias_off]}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <FiltroSelect
                                                            name="tipoRedes"
                                                            placeholder={"Todos los tipos de redes"}
                                                            isLoading={isLoading}
                                                            titulo={"Nombre de red:"}
                                                            options={tipoRedes.map(
                                                                p =>
                                                                    (p = {
                                                                        value: p.id,
                                                                        label: p.red,
                                                                        tipo: grupos.tipoRed,
                                                                    })
                                                            )}
                                                            value={values["tipoRedes"]}
                                                        />
                                                        <FiltroSelect
                                                            name="especialidades"
                                                            placeholder={"Todas las especialidades"}
                                                            isLoading={isLoading}
                                                            titulo={"Especialidad:"}
                                                            options={especialidades.map(
                                                                p =>
                                                                    (p = {
                                                                        value: p,
                                                                        label: p,
                                                                        tipo: grupos.especialidad,
                                                                    })
                                                            )}
                                                            value={values["especialidades"]}
                                                        />
                                                        <FiltroSelect
                                                            name="ciudades"
                                                            placeholder={"Todas las ciudades"}
                                                            isLoading={isLoading}
                                                            titulo={"Ciudad:"}
                                                            options={ciudades.map(
                                                                p =>
                                                                    (p = {
                                                                        value: p.nmCiudad,
                                                                        label: `${p.nmCiudad} - ${p?.nmProvincia}`,
                                                                        tipo: grupos.ciudad,
                                                                    })
                                                            )}
                                                            value={values["ciudades"]}
                                                        />
                                                        <FiltroSelect
                                                            name="prestadores"
                                                            placeholder={"Todos los prestadores"}
                                                            isLoading={isLoading}
                                                            titulo={"Prestador:"}
                                                            options={prestadores.map(
                                                                p =>
                                                                    (p = {
                                                                        value: p,
                                                                        label: p,
                                                                        tipo: grupos.prestador,
                                                                    })
                                                            )}
                                                            value={values["prestadores"]}
                                                        />
                                                        <div className="col-12 beneficios">
                                                            <div className={"text-center text-primary pt-1 iconito"}>
                                                                <i className={"fas fa-angle-double-down fa-bounce"} />
                                                            </div>
                                                            <div
                                                                className="beneficios__buscar pt-1 pb-2 c-pointer"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <button
                                                                    type={"button"}
                                                                    className={"btn beneficios__btn"}
                                                                    onClick={e => {
                                                                        submitForm();
                                                                    }}
                                                                >
                                                                    <img src={buscar} alt="" width={"15"} />
                                                                    &nbsp;
                                                                    <span>Buscar</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Collapse>
                                                {!open && (
                                                    <div
                                                        className="col-12 prestadores-filtro beneficios c-pointer"
                                                        onClick={() => setOpen(true)}
                                                    >
                                                        <div className="beneficios__buscar-closed py-2 text-center">
                                                            <h1 className={""}>
                                                                <img src={icon_filtro} width={"20"} alt="" />
                                                                &nbsp;Filtro
                                                            </h1>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {beneficios?.length > 0 ? (
                                                <>
                                                    <div
                                                        className={`${open ? "col" : "col-md-12"} agrupamiento-select`}
                                                    >
                                                        <div className={`row my-2 pb-3 bordecito`}>
                                                            <div className="col-8 col-md-6 col-lg-4">
                                                                <span className={"text-primary"}>Agrupar por:</span>
                                                                <Select
                                                                    isDisabled={!showCardPeque}
                                                                    styles={customStyles}
                                                                    placeholder={"Todos"}
                                                                    name={"agrupamiento"}
                                                                    options={gruposList}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={e => handleAgrupamiento(e)}
                                                                    defaultValue={agrupamientoSeleccionado}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className={"mb-3"}>
                                                            {Object.keys(values || {}).map((v, idx) => (
                                                                <span key={idx}>
                                                                    {values[v]?.length > 0 &&
                                                                        values[v].map((l, idx2) => (
                                                                            <small key={idx2} className={"etiquetas"}>
                                                                                <div className={"etiqueta__nombre"}>
                                                                                    <span>
                                                                                        {findRed(l?.label || l) ||
                                                                                            l?.label}{" "}
                                                                                    </span>
                                                                                    &nbsp;
                                                                                    <img
                                                                                        className={"c-pointer"}
                                                                                        src={cerrar_green}
                                                                                        width={"9"}
                                                                                        onClick={() =>
                                                                                            handleRemoveTags(
                                                                                                l,
                                                                                                v,
                                                                                                values,
                                                                                                setFieldValue
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </small>
                                                                        ))}
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <div className="cards__peque">
                                                            {Object.keys(beneficiosAgrupados || {}).map(
                                                                (grupo, idx) => (
                                                                    <div key={idx}>
                                                                        {handleGrupoNm(grupo) && showCardPeque && (
                                                                            <div className="bordecito grupo-separacion mb-2 text-primary">
                                                                                <h5 className={"font-weight-bold"}>
                                                                                    {handleGrupoNm(grupo)}
                                                                                </h5>
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className={`row ${open && "justify-content-around"}`}
                                                                        >
                                                                            {(beneficiosAgrupados[grupo] || []).map(
                                                                                (beneficio, idx) => (
                                                                                    <React.Fragment key={idx}>
                                                                                        <BeneficioCardGrande
                                                                                            open={open}
                                                                                            espere={espere}
                                                                                            print={print}
                                                                                            beneficio={beneficio}
                                                                                            windowWidth={
                                                                                                window.innerWidth
                                                                                            }
                                                                                        />
                                                                                    </React.Fragment>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div
                                                    className={`${open ? "col" : "col-xl"} home-slider prestadores-slider`}
                                                >
                                                    <CarouselPrestadores />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Formik>
                </div>
            </div>
            <ModalCargando
                open={espere}
                title={"Descargando Beneficio"}
                subtitule={"Por favor espere, descargando..."}
            />
        </>
    );
};

const FiltroSelect = ({ titulo, name, options, value = [], isLoading, placeholder }) => {
    const actions = useFormikContext();
    return (
        <>
            <div className={"bordecito"}>
                <div className="filtro">
                    <h1>{titulo}</h1>
                    <Select
                        styles={customStyles}
                        isMulti
                        placeholder={placeholder}
                        isLoading={isLoading}
                        name={name}
                        options={options}
                        value={value}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        noOptionsMessage={({ inputValue }) => !inputValue && "No existen resultados"}
                        onChange={e => {
                            actions.setFieldValue(name, e);
                        }}
                    />
                </div>
            </div>
        </>
    );
};

const RedCard = ({ title, iconos, red }) => {
    const actions = useFormikContext();
    const { redes } = actions.values;

    const [icono, setIcono] = useState(iconos[0]);

    const handleIconoOn = () => {
        setIcono(iconos[1]);
    };

    const handleIconoOff = () => {
        setIcono(iconos[0]);
    };

    const handleCheck = () => {
        let redcita = redes.find(r => r === red);
        if (redcita) {
            actions.setFieldValue(
                "redes",
                redes.filter(r => r !== red)
            );
        } else {
            actions.setFieldValue("redes", [...redes, red]);
        }
    };

    return (
        <div className={"col-xl-3 col-6 px-2"}>
            <div
                className={"text-center c-pointer borde-redes-prestadores"}
                onMouseEnter={handleIconoOn}
                onMouseLeave={handleIconoOff}
                onClick={handleCheck}
            >
                <div className={"checkbox"}>
                    <img src={redes.find(r => r === red) ? check_on : check_off} />
                </div>
                <div>
                    <img src={icono} />
                </div>
                <h4>{title}</h4>
            </div>
        </div>
    );
};
